export default {
    CALL: 'CALL',
    NOTE: 'NOTE',
    MAIL: 'EMAIL',
    RDV: 'RDV',
    FILE: 'FILE'
}
